import { CookieHelper } from './CookieHelper';
var CONSENT_COOKIE = 'CookieInformationConsent';
export var getConsentCookie = function () {
    return CookieHelper.getInstance().get(CONSENT_COOKIE);
};
export var getNecesarryConsent = function () {
    try {
        return getConsentCookie().consents_approved.find(function (v) { return v === 'cookie_cat_necessary'; }) !== undefined;
    }
    catch (error) {
        return false;
    }
};
export var getFunctionalConsent = function () {
    try {
        return getConsentCookie().consents_approved.find(function (v) { return v === 'cookie_cat_functional'; }) !== undefined;
    }
    catch (error) {
        return false;
    }
};
export var getStatisticConsent = function () {
    try {
        return getConsentCookie().consents_approved.find(function (v) { return v === 'cookie_cat_statistic'; }) !== undefined;
    }
    catch (error) {
        return false;
    }
};
export var getMarketingConsent = function () {
    try {
        return getConsentCookie().consents_approved.find(function (v) { return v === 'cookie_cat_marketing'; }) !== undefined;
    }
    catch (error) {
        return false;
    }
};
export var getUnclassifiedConsent = function () {
    try {
        return getConsentCookie().consents_approved.find(function (v) { return v === 'cookie_cat_unclassified'; }) !== undefined;
    }
    catch (error) {
        return false;
    }
};
/**
 * This funcition will add a script to the document for loading the Novozymes
 * cookie consent popup
 */
export var initializeCookieConsent = function () {
    var script = document.createElement('script');
    script.src = 'https://policy.app.cookieinformation.com/uc.js';
    script.async = true;
    script.setAttribute('data-culture', 'EN');
    script.type = 'text/javascript';
    script.id = 'CookieConsent';
    document.body.appendChild(script);
};
